import { encodeBase64 as base64  } from './lib.base64'

export const filterSetup = (data?: Array<[string, any]> | null): string => {
	//const encode = ([k, v]: [string, any]) => [k, base64(JSON.stringify(v ?? null))].map(encodeURIComponent).join(':')
	const encode = ([k, v]: [string, any]) => [k, base64(JSON.stringify(v ?? null))].join(':')

	return data?.map(encode).join(',') ?? ''
}
